import React, { useEffect } from 'react';
import './pb2026.css';


const Pb2026 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Padrones de Beneficiarios 2026</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
             
              <div style={{ textAlign: 'left' }}>

              <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Subsecretaría de Inclusión y Desarrollo</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                     <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2026/PUB_SVV_1er_T_2026.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Subsidio al Servicio de Verificación Vehicular Primer Trimestre 2026
                      </a>
                    </strong>
                    <br /> 
                  </li>
                  
                </ul>
              
                {/* Añade el resto de los bloques aquí */}
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Pb2026;
